import React, { useState, useEffect } from 'react';
import { INACTIVITY_TIMEOUT_MS, COUNTDOWN_SECONDS } from './constants';

interface Props {
  lastSpeechTimestamp: React.MutableRefObject<number>;
  onTimeout: () => void;
  enabled: boolean;
}

export const InactivityGuard: React.FC<Props> = ({ lastSpeechTimestamp, onTimeout, enabled }) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [countdown, setCountdown] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    if (!enabled) { setShowPrompt(false); return; }

    const interval = setInterval(() => {
      const elapsed = Date.now() - lastSpeechTimestamp.current;
      if (elapsed > INACTIVITY_TIMEOUT_MS && !showPrompt) {
        setShowPrompt(true);
        setCountdown(COUNTDOWN_SECONDS);
      } else if (elapsed <= INACTIVITY_TIMEOUT_MS && showPrompt) {
        setShowPrompt(false);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [enabled, showPrompt, lastSpeechTimestamp]);

  useEffect(() => {
    if (!showPrompt) return;
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) { onTimeout(); return 0; }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [showPrompt, onTimeout]);

  if (!showPrompt) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <div className="bg-[#1C1C1E] rounded-2xl p-8 text-center border border-white/10">
        <p className="text-2xl text-white mb-2">Still there?</p>
        <p className="text-white/50 text-lg">Session will end in {countdown}s</p>
        <button
          onClick={() => { lastSpeechTimestamp.current = Date.now(); setShowPrompt(false); }}
          className="mt-4 px-6 py-2 bg-[#30D158]/20 text-[#30D158] rounded-xl border border-[#30D158]/30"
        >
          I'm here!
        </button>
      </div>
    </div>
  );
};
